// removed by extract-text-webpack-plugin
module.exports = {"usDollarsNotice":"_23OGJ"};